import { z } from 'zod/v3';

// ============================================================================
// Refund Model 스키마
// ============================================================================

/**
 * 환불 계좌 응답 스키마
 * @see GET /api/market-place/v1/payments/refund-account
 */
export const refundAccountSchema = z.object({
  /** 계좌번호 */
  accountNumber: z.string().optional(),
  /** 은행코드 (3자리) */
  bankCode: z.string().optional(),
  /** 은행명 (한글) */
  bankKorName: z.string().optional(),
  /** 은행명 */
  bankName: z.string().optional(),
  /** 예금주명 */
  holderName: z.string().optional(),
});
export type RefundAccount = z.infer<typeof refundAccountSchema>;

/**
 * 은행 정보 스키마
 * @see GET /api/market-place/v1/payments/kpn/vacct/bank-refund
 */
export const bankSchema = z.object({
  /** 은행 코드 */
  bankCode: z.string(),
  /** 은행명 */
  bankName: z.string(),
});
export type Bank = z.infer<typeof bankSchema>;

/**
 * 환불 계좌 확인(예금주 조회) 응답 스키마
 * @see POST /api/market-place/v2/payments/refund-account-check
 */
export const refundAccountCheckSchema = z.object({
  /** 예금주명 */
  holderName: z.string(),
});
export type RefundAccountCheck = z.infer<typeof refundAccountCheckSchema>;
